<template>
  <div>
    <el-drawer
      v-if="visible"
      :title="title"
      :visible="visible"
      direction="rtl"
      :size="800"
      show-close
      @close="close"
      :before-close="handleClose"
      append-to-body
    >
      <div class="px-4">
        <div class="d-flex justify-content-between align-items-center mb-4">
          <div style="color: #101010 ; font-size: 20px;">
            {{ title }}
          </div>
          <div>
            <el-button size="mini" type="primary" @click="confirm()">
              {{ $l('drawer_button_add') || '确认添加' }}
            </el-button>
          </div>
        </div>
        <el-checkbox-group v-model="qualityIssues" placement="column">
          <div v-for="(t, key) in issuesList" :key="key" class="mb-4">
            <div
              style="color: #101010; height: 20px;font-size: 16px;"
              class="mb-3"
            >
              {{ t.defectIssuesGroup }}
            </div>
            <div>
              <el-checkbox
                v-for="option in t.items"
                :key="option.defectIssuesCode"
                :label="option.defectIssuesCode"
              >
                {{ option.defectIssuesTitle }}
              </el-checkbox>
            </div>
            <div v-if="getOtherProblemCode(t.items)" class="mt-3">
              <div
                style="font-size: 14px; line-height: 22px;"
                class="mb-2"
              >
                其他问题描述
              </div>
              <el-input
                v-model="otherProblemDesc"
                type="textarea"
                :rows="4"
                maxlength="500"
                show-word-limit
                placeholder="请输入其他问题描述"
              />
            </div>
          </div>
        </el-checkbox-group>
      </div>
    </el-drawer>
    <CloseDialog :backDialogVisible.sync="backDialogVisible" @close="close" />
  </div>
</template>
<script>
import CloseDialog from '../../../close-dialog/index.vue'
import EditLoading from '@/mixins/edit-loading'
import lodash from 'lodash'
export default {
  components: {
    CloseDialog,
  },
  mixins: [EditLoading],
  props: {
    visible: { type: Boolean, default: false },
    title: {
      type: String,
      default: '疵点原因选择',
    },
    inspectionDetailCode: { type: String, default: '' },
    issueType: { type: String, default: '' },
    selectedData: { type: Array, default: () => [] },
  },
  data() {
    return {
      backDialogVisible: false,
      issuesList: [],
      issuesObjectList: [],
      issuesMap: [],
      qualityIssues: [],
      otherProblemDesc: '',
    }
  },
  async mounted() {
    await this.getData()
  },

  methods: {
    close() {
      this.$emit('update:visible', false)
      // this.$emit('close')
    },

    handleClose() {
      this.backDialogVisible = true
    },
    confirm() {
      if (!this.qualityIssues || this.qualityIssues.length === 0) {
        this.$message.warning('请选择问题')
        return
      }
      const filtered = this.issuesObjectList
        .filter((item) => this.qualityIssues.includes(item.defectIssuesCode))
        .map((item) => ({
          ...item,
          otherProblemDesc: this.shouldShowOtherProblemDesc(item)
            ? this.otherProblemDesc.trim()
            : '',
        }))
      this.$emit('confirm', filtered)
    },
    async getData() {
      this.loadingOpen()
      const res = await this.$api
        .inspectionDefectIssuesListApi({ issueType: this.issueType })
        .catch(() => null)
      this.loadingClose()
      this.issuesObjectList = res.body.data
      this.issuesList = lodash.mapValues(
        lodash.groupBy(res.body.data, 'defectIssuesGroup'),
        (items) => {
          const { defectIssuesGroup } = items[0]
          return { defectIssuesGroup, items }
        }
      )
      this.qualityIssues = lodash.cloneDeep(this.selectedData)
      this.otherProblemDesc = ''
    },
    shouldShowOtherProblemDesc(item = {}) {
      return (
        this.issueType === 'B' &&
        (item.defectIssuesTitle || '').trim() === '其他' &&
        this.qualityIssues.includes(item.defectIssuesCode)
      )
    },
    getOtherProblemCode(items = []) {
      const otherOption = items.find((item) => this.shouldShowOtherProblemDesc(item))
      return otherOption?.defectIssuesCode || ''
    },
  },
}
</script>
